<template>
  <v-card class="mr-auto ma-1" max-width="320">
    <v-img
      :src="loadImg"
      @error="loadDefaultImg"
      height="200px">
    </v-img>
    <v-card-title>
        {{ product.title }}  
    </v-card-title>
    <v-card-text>
        R$ {{ product.price }}
    </v-card-text>
    <v-card-subtitle>
        {{ product.description }}  
    </v-card-subtitle>    
    <v-card-actions>
        <v-btn color="green" v-if="!product.isAddedToCart" text @click="addToCart(product.id)" >Adicionar ao carrinho</v-btn>           
        <v-btn color="red" v-if="product.isAddedToCart" text @click="removeFromCart(product.id)" >Remover do carrinho</v-btn>           
    </v-card-actions>    
  </v-card>
</template>


<script>
    import { ADD_TO_CART, REMOVE_FROM_CART } from '../store/actions/store';
    import Api from '../services/Api';
    export default {
        data: () => ({
            showDefaultImg: false        
        }),
        props: {
            product: {
                type: Object,
                required: true
            }
        },
        methods:{
            loadDefaultImg(){
                this.showDefaultImg = true;
            },
            addToCart(id){
                this.$store.dispatch(ADD_TO_CART, {id});
            },
            removeFromCart(id){
                this.$store.dispatch(REMOVE_FROM_CART, {id});
            }
        },
        computed:{
            loadImg: function(){
                if(this.showDefaultImg){
                    return "https://cdn.vuetifyjs.com/images/cards/store.jpg"
                }
                if(this.product.media != undefined){
                    return Api.getBaseUrl()+"imagens/"+this.product.media.name
                }
                return "https://cdn.vuetifyjs.com/images/cards/store.jpg";
            }
        }
    }
</script>